import {defineMessages} from 'react-intl';

export default defineMessages({
	exchangeCheckboxLabel: {
		id: 'returnAuthCreateForm.step1.exchangeCheckboxLabel',
		defaultMessage: 'Exchange?',
	},
	sizeSelector: {
		id: 'productDetail.sizeSelector',
		defaultMessage: 'Select size'
	},
	sizeSelectorSelected: {
		id: 'productDetail.sizeSelectorSelected',
		defaultMessage: 'Size'
	},
	colorSelector: {
		id: 'productDetail.colorSelector',
		defaultMessage: 'Select color'
	},
	colorSelectorSelected: {
		id: 'productDetail.colorSelectorSelected',
		defaultMessage: 'Color'
	},
});
